// Цветовые палитры ECMIT. Источник токенов — ecmit-landing (src/style.css), CSS-шкалы CRM —
// src/styles/palettes.css (генерируется webapp/scripts/gen_palettes.py).
export type Palette = 'mint' | 'graphite' | 'amber' | 'blue' | 'rose' | 'contrast'

export const PALETTES: { id: Palette; label: string; color: string }[] = [
  { id: 'mint', label: 'Мята', color: '#087f68' },
  { id: 'graphite', label: 'Графит', color: '#334155' },
  { id: 'amber', label: 'Янтарь', color: '#b45309' },
  { id: 'blue', label: 'Синий — при красно-зелёной слепоте (дейтеро-, протанопия)', color: '#0060a8' },
  { id: 'rose', label: 'Малиновый — при сине-жёлтой слепоте (тританопия)', color: '#b3123e' },
  { id: 'contrast', label: 'Контрастный чёрно-белый', color: '#000000' },
]

const STORAGE_KEY = 'palette'
const CHANGED_EVENT = 'ecmit:palette'
// Свой выбор человека не должен откатываться опросом сервера, пока новое значение ещё не сохранилось.
const LOCAL_CHANGE_GRACE_MS = 20_000
let lastLocalChange = 0

export function isPalette(value: unknown): value is Palette {
  return PALETTES.some((palette) => palette.id === value)
}

/** Ставит палитру на <html>. null/неизвестное значение — прежний синий CRM (палитра не выбрана). */
export function applyPalette(value: Palette | null | undefined): void {
  const root = document.documentElement
  if (isPalette(value)) {
    root.dataset.palette = value
    try { localStorage.setItem(STORAGE_KEY, value) } catch { /* private mode */ }
  } else {
    delete root.dataset.palette
    try { localStorage.removeItem(STORAGE_KEY) } catch { /* private mode */ }
  }
  window.dispatchEvent(new Event(CHANGED_EVENT))
}

/** Пометить, что палитру только что выбрали руками: опрос сервера её пока не трогает. */
export function markLocalPaletteChange(): void {
  lastLocalChange = Date.now()
}

/** Выбор не удалось сохранить на сервере: до перезагрузки страницы он остаётся главным и опрос его не откатывает. */
export function holdLocalPalette(): void {
  lastLocalChange = Number.MAX_SAFE_INTEGER
}

export function recentlyChangedLocally(): boolean {
  return lastLocalChange === Number.MAX_SAFE_INTEGER || Date.now() - lastLocalChange < LOCAL_CHANGE_GRACE_MS
}

/** Подписка на смену палитры (выбор в меню или обновление с сервера). Возвращает отписку. */
export function onPaletteChange(listener: () => void): () => void {
  window.addEventListener(CHANGED_EVENT, listener)
  return () => window.removeEventListener(CHANGED_EVENT, listener)
}

export function currentPalette(): Palette | null {
  const value = document.documentElement.dataset.palette
  return isPalette(value) ? value : null
}
